import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

/**
 * Custom Create form fields. `CellPicker` lists the cells in the Delivery
 * Registry so the onboarding template can target ACK, TKE, or GKE cells
 * without a template change per cell.
 */
export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'service-registration-picker',
      params: {
        field: () =>
          import('./ServiceRegistrationPicker').then(
            module => module.serviceRegistrationFormField,
          ),
      },
    }),
    FormFieldBlueprint.make({
      name: 'deployment-targets-picker',
      params: {
        field: () =>
          import('./DeploymentTargetsPicker').then(
            module => module.deploymentTargetsPickerFormField,
          ),
      },
    }),
    FormFieldBlueprint.make({
      name: 'cell-picker',
      params: {
        field: () =>
          import('./CellPicker').then(module => module.cellPickerFormField),
      },
    }),
  ],
});
